export class UserRoles {
  isCandidate: boolean = false;
  isEmployer: boolean = false;
  isBusiness: boolean = false;

  isSeafarer: boolean = false;
  isOnshore: boolean = false;
  isOilAndGas: boolean = false;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./app/core/services/role/role-statuses.ts